// AUTO-GENERATED from UPV store catalog (catalog_2026-07-24). Real per-country visa data.
export const VISA_CATALOG = {
  "algeria": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Algeria+Visa+Application+Form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Algeria+Visa+Application+Form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "azerbaijan": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Visa_Application_Form_Azerbaijan.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Visa_Application_Form_Azerbaijan.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "bangladesh": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed Visa Application Form",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://visa.gov.bd/"
          }
        },
        {
          "title": "Passport Photo",
          "desc": "One 2×2 inch color photo on a plain white or light background"
        },
        {
          "title": "Travel Proof",
          "desc": "Copy of airline ticket or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of Driver’s License"
        },
        {
          "title": "Valid U.S. Passport",
          "sub": [
            "Must be valid for at least 6 months beyond your return date",
            "You must ship your actual passport (no photocopies)"
          ]
        },
        {
          "title": "Payment of Fees"
        }
      ],
      "fees": [
        {
          "label": "Tourist Visa",
          "processing": "5–7 Business Days",
          "embassy": 165,
          "upv": 150,
          "total": 315
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed Visa Application Form",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://visa.gov.bd/"
          }
        },
        {
          "title": "Passport Photo",
          "desc": "One 2×2 inch color photo on a plain white or light background"
        },
        {
          "title": "Travel Proof",
          "desc": "Copy of airline ticket or itinerary showing arrival and departure dates"
        },
        {
          "title": "Valid U.S. Passport",
          "desc": "Must be valid for at least 6 months beyond your travel date"
        },
        {
          "title": "Business Letter of Responsibility/Guarantee",
          "sub": [
            "Must be typed on company letterhead and addressed to the embassy",
            "Include: Nature of business to be performed Name and address of business contact in destination country Guarantee of return transportation and sufficient funds",
            "Must be signed by a company officer other than the applicant"
          ]
        },
        {
          "title": "Payment of Fees"
        }
      ],
      "fees": [
        {
          "label": "Business Visa",
          "processing": "5–7 Business Days",
          "embassy": 165,
          "upv": 150,
          "total": 315
        }
      ]
    },
    "notes": [
      "Processing time: 5–7 business days for both visa types",
      "Same-day processing is not available for Business Visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and must be arranged separately"
    ]
  },
  "belarus": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Belarus-Visa+App+Form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Belarus-Visa+App+Form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "benin": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Benin-Visa+App+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Benin-Visa+App+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "bolivia": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://visas.cancilleria.gob.bo/#/registrarme"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://visas.cancilleria.gob.bo/#/registrarme"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "brazil": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed Visa Application Form",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://formulario-mre.serpro.gov.br/sci/pages/web/ui/#/instrucoes-iniciais-visto"
          }
        },
        {
          "title": "Passport Photo",
          "desc": "One (1) 2×2 inch color photo with a plain light or white background"
        },
        {
          "title": "Travel Proof",
          "desc": "Copy of airline ticket or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of Driver’s License"
        },
        {
          "title": "Valid U.S. Passport",
          "sub": [
            "You must ship your original passport (no photocopies)",
            "Passport must be valid for at least 6 months beyond your return date"
          ]
        },
        {
          "title": "Payment of Fees"
        }
      ],
      "fees": [
        {
          "label": "Tourist Visa",
          "processing": "5–7 Business Days",
          "embassy": 160,
          "upv": 250,
          "total": 410
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed Visa Application Form",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://formulario-mre.serpro.gov.br/sci/pages/web/ui/#/instrucoes-iniciais-visto"
          }
        },
        {
          "title": "Passport Photo",
          "desc": "One (1) 2×2 inch color photo with a plain light or white background"
        },
        {
          "title": "Travel Proof",
          "desc": "Copy of airline ticket or itinerary showing arrival and departure dates"
        },
        {
          "title": "Valid U.S. Passport",
          "desc": "Must be valid for at least 6 months beyond travel date"
        },
        {
          "title": "Business Letter of Responsibility/Guarantee",
          "sub": [
            "Must be typed on company letterhead and addressed to the embassy",
            "Should include: Purpose and nature of business in Brazil Name and address of business contact in Brazil Guarantee of return transportation and sufficient funds for the visit",
            "Must be signed by a company officer other than the applicant"
          ]
        },
        {
          "title": "Payment of Fees"
        }
      ],
      "fees": [
        {
          "label": "Business Visa",
          "processing": "5–7 Business Days",
          "embassy": 160,
          "upv": 250,
          "total": 410
        }
      ]
    },
    "notes": []
  },
  "burkina-faso": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Burkina-1.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Burkina-1.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "burundi": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Burundi-1+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Burundi-1+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "cambodia": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Cambodia-1+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Cambodia-1+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "cameroon": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/CameroonApplicationForm-Visa.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/CameroonApplicationForm-Visa.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "cape-verde": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Cape-Verde+visa+from.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Cape-Verde+visa+from.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "central-african-republic": {
    "tourist": {
      "requirements": [
        {
          "title": "To apply for a tourist visa to the Central African Republic, please prepare the following documents:",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Central+African+Republic+visa+form.pdf"
          },
          "sub": [
            "Valid U.S. Passport Your passport must be original, signed, and valid for at least 6 months beyond your intended stay. It must also have at least two blank visa pages for entry and exit stamps. (Note: Amendment pages at the back of the passport are not acceptable for visas or stamps.)",
            "Passport-Style Photos Provide two (2) recent color photos (2\" x 2\") with a white background. Photos must be front-facing and taken within the last six months",
            "Yellow Fever Vaccination Certificate A copy of your International Certificate of Vaccination for Yellow Fever is required",
            "Travel Itinerary Include a copy of your round-trip ticket or confirmed travel itinerary showing entry and exit dates",
            "Proof of Accommodation Provide a copy of your hotel reservation or other lodging arrangements. The reservation must clearly list the applicant's name"
          ]
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Central+African+Republic+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "chad": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Chad.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Chad.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "china": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed Visa Application Form",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://cova.mfa.gov.cn/qzCoCommonController.do?show&pageId=index&locale=en_US"
          }
        },
        {
          "title": "Passport Photo",
          "desc": "One 2×2 inch color photo on a plain light or white background"
        },
        {
          "title": "Copy of Driver’s License"
        },
        {
          "title": "Current Valid U.S. Passport"
        },
        {
          "title": "Accommodation Information",
          "desc": "Fill out the “Where You Stay” section on the application form"
        },
        {
          "title": "Payment of Fees"
        }
      ],
      "fees": [
        {
          "label": "Tourist Visa",
          "processing": "5–7 Business Days",
          "embassy": 140,
          "upv": 250,
          "total": 390
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed Visa Application Form",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://cova.mfa.gov.cn/qzCoCommonController.do?show&pageId=index&locale=en_US"
          }
        },
        {
          "title": "Passport Photo",
          "desc": "One 2×2 inch color photo on a plain light or white background"
        },
        {
          "title": "Current Valid U.S. Passport"
        },
        {
          "title": "Copy of Driver’s License"
        },
        {
          "title": "Letter of Invitation",
          "desc": "From the company in China, with official stamp"
        },
        {
          "title": "Accommodation Information",
          "desc": "Fill out the “Where You Stay” section on the application form"
        },
        {
          "title": "Business Letter from Your Company",
          "sub": [
            "Typed on official letterhead",
            "States duration and purpose of travel",
            "Confirms financial responsibility"
          ]
        },
        {
          "title": "Payment of Fees"
        }
      ],
      "fees": [
        {
          "label": "Business Visa",
          "processing": "5–7 Business Days",
          "embassy": 140,
          "upv": 250,
          "total": 390
        }
      ]
    },
    "notes": []
  },
  "colombia": {
    "tourist": {
      "requirements": [],
      "fees": []
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://tramitesmre.cancilleria.gov.co/tramites/enlinea/solicitarVisaIE.xhtml"
          }
        },
        {
          "title": "You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "A business letter of responsibility/guarantee is required to be typewritten on your company letterhead and addressed to the embassy, explaining nature of business to be performed, name and address of business reference in country to be visited, guarantee of return transportation and sufficient funds for the visit. This letter must be signed by an officer of the company other than the applicant"
        },
        {
          "title": "Letter from Government Agency: If applying for a government contractor visa, a letter from the government agency or DoD authorization is required"
        },
        {
          "title": "Payment of Fees"
        }
      ],
      "fees": []
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "dr-congo": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/DRC_visas_application.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/DRC_visas_application.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "congo-republic": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Republic-of-Congo+visa+from.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Republic-of-Congo+visa+from.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "djibouti": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Djibouti-Visa-Application.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Djibouti-Visa-Application.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "egypt": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://egyptembassy.net/consular-services/visas-travel/visa-requirements/"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://egyptembassy.net/consular-services/visas-travel/visa-requirements/"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "equatorial-guinea": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/EGVISAAPP.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/EGVISAAPP.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "eritrea": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Eritrea.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Eritrea.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "ethiopia": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Ethiopia+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Ethiopia+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "gabon": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Gabon+upv+visa+app+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Gabon+upv+visa+app+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "gambia": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/GAMBIA-VISA-APPLICATION-FORM-2020.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/GAMBIA-VISA-APPLICATION-FORM-2020.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "ghana": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/GHANA-visa-APPL-2017-1.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/GHANA-visa-APPL-2017-1.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "guinea": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Guinea-Republic+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Guinea-Republic+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "india": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://indianvisaonline.gov.in/"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://indianvisaonline.gov.in/"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "indonesia": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://consular.embassyofindonesia.org/"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://consular.embassyofindonesia.org/"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "iran": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/UPV+WORK+ORDER+FORM+V2.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/UPV+WORK+ORDER+FORM+V2.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "iraq": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Iraq+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Iraq+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "ivory-coast": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Ivory-Coast-1+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Ivory-Coast-1+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "jordan": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Jordan-application+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Jordan-application+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "kazakhstan": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Kazakhstan+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Kazakhstan+visa+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "kenya": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/kenya+application+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/kenya+application+form.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "kuwait": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/UPV+Kuwait-Visa-Application.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/UPV+Kuwait-Visa-Application.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "nigeria": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/NIGERIA-APP-VISA+FORM.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "Multiple Entry",
          "processing": "7-10 Business Days",
          "embassy": 270,
          "upv": 250,
          "total": 520
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/NIGERIA-APP-VISA+FORM.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "Multiple Entry",
          "processing": "7-10 Business Days",
          "embassy": 270,
          "upv": 250,
          "total": 520
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "qatar": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Qatar-Visa-Application.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Qatar-Visa-Application.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "russia": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://visa.kdmid.ru/"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": null,
          "upv": 250,
          "total": null
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": null,
          "upv": 250,
          "total": null
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": null,
          "upv": 250,
          "total": null
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": null,
          "upv": 250,
          "total": null
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://visa.kdmid.ru/"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": null,
          "upv": 250,
          "total": null
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": null,
          "upv": 250,
          "total": null
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": null,
          "upv": 250,
          "total": null
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": null,
          "upv": 250,
          "total": null
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "rwanda": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Rwanda+UPV.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/Rwanda+UPV.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  },
  "turkey": {
    "tourist": {
      "requirements": [
        {
          "title": "Completed visa application form. Regular visa application Rush visa application",
          "form": {
            "name": "Download Application Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/UPV+WORK+ORDER+FORM+V2.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Copy of recent bank statement"
        },
        {
          "title": "Signed and notarized letter of consent from both parents, copy of parent’s ID(Driver's License, etc), a copy of the applicant's birth certificate"
        },
        {
          "title": "Current valid US passport. You must ship your actual US passport (no photocopies). Your passport should remain valid for the next 6 months"
        },
        {
          "title": "Copy of yellow fever vaccination certificate"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 315
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "business": {
      "requirements": [
        {
          "title": "Completed visa application form. Submit 1 copie(s) of the visa application form. Print, sign, and fill out completely",
          "form": {
            "name": "Fill Out This Form",
            "url": "https://irp.cdn-website.com/de603881/files/uploaded/UPV+WORK+ORDER+FORM+V2.pdf"
          }
        },
        {
          "title": "One passport photo (2×2 inches, color, with a plain light or white background)"
        },
        {
          "title": "Copy of airline tickets or itinerary showing arrival and departure dates"
        },
        {
          "title": "Current valid US passport"
        },
        {
          "title": "Payment of applicable fees"
        }
      ],
      "fees": [
        {
          "label": "3 Months Single Entry",
          "processing": "10 Business Days",
          "embassy": 65,
          "upv": 250,
          "total": 350
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "10 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "3 Months Single Entry",
          "processing": "2 Business Days",
          "embassy": 105,
          "upv": 250,
          "total": 355
        },
        {
          "label": "1 Year Multiple Entry",
          "processing": "2 Business Days",
          "embassy": 205,
          "upv": 250,
          "total": 455
        }
      ]
    },
    "notes": [
      "Processing time for both visas is 5-7 business days",
      "Same-day processing is not available for business visas",
      "Additional charges may apply for out-of-DC jurisdiction",
      "Shipping fees are not included and should be arranged separately"
    ]
  }
};
